import InputtingDataFrom from './InputtingDataFrom'

export default InputtingDataFrom
